export default __webpack_public_path__ + "svg/ceo/innovation.svg?22874ac4";